import { Box, Typography } from "@mui/material"
import Frame from "components/Frame"
import Highlight from "components/Highlight"

const style={
  width: '100%',
  height: '800px',
  display: 'block',
  objectFit: 'cover',
  objectPosition: 'center'
}

const spacer = <Box m={4}/>

const Highlights = () => {
  return (
    <Box>

      <Highlight
        title = "Monochrome"
        subtitle = {
          <>
            <Typography fontFamily="General Sans" fontSize="0.9rem" style={{lineHeight: 1.2}}>
              A work in progress
            </Typography>
          </>
        }
        year = "2026"
        content = {(<img src="media/art/lg/ptvs9.png" alt="" style={style}></img>)}
        align = "left"
      />

      {spacer}
      
      <Highlight
        title = "Envelop"
        subtitle = {
          <>
            <Typography fontFamily="General Sans" fontSize="0.9rem" style={{lineHeight: 1.2}}>
              Envelop is an algorithm born through the recreation of Aldo Giorgini's numerical visualization software <i>FIELDS</i>. Giorgini's highly coveted
              - now seemingly lost - Fortran library simulated what he called "fields", reminiscent of topographic contour lines. Geometric 
              arrangements and stark color schemes were central to his visual identity.
            </Typography>
            <Box m={1}></Box>
            <Typography fontFamily="General Sans" fontSize="0.9rem" style={{lineHeight: 1.2}}>
              In a similar spirit, Envelop explores the tension between clashing archetypal shapes - growing, colliding, and sometimes devouring - quietly 
              evolving into tangled organic forms; open to interpretation or simply for aesthetic enjoyment, ad libitum.
            </Typography>
          </>
        }
        year = "2025"
        content = {<img src="media/art/lg/segtw.png" alt="" style={style}></img>}
        link = "https://envelop.pxlq.art"
        align = "right"
      />

      {spacer}

      <Highlight
        title = "Syndication"
        subtitle = {
          <>
            <Typography fontFamily="General Sans" fontSize="0.9rem" style={{lineHeight: 1.2}}>
              We live in a world that seeks our attention, yet we must contend with hostile algorithms merely to function in this digital age. How do we stay 
              connected to the things we care about without being consumed by the <i>platforms</i> that host it? Avoid them. Host your own sites, 
              blog, API. Share your content directly and curate your own network of feeds. Syndication is a small step towards silencing the noise and existing 
              online on our own terms. A prototype for RSS feeds for generative algorithms; pushing hashes daily, weekly, or monthly to recipients. 
            </Typography>
          </>
        }
        year = "2025"
        content = {<Frame url={"https://api.pxlq.art/project/mathfont?render"} style={style}/>}
        link = "https://github.com/latent-laboratory/rss"
        align = "left"
      />
    </Box>
  )
}

export default Highlights